
import { Vue } from "vue-class-component";

export default class ProductRangeView extends Vue {}
